var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgNotify(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.6002 19.8006C10.7018 20.1468 10.9128 20.4507 11.2016 20.6669C11.4904 20.8831 11.8415 21 12.2023 21C12.563 21 12.9141 20.8831 13.2029 20.6669C13.4917 20.4507 13.7027 20.1468 13.8043 19.8006",
    stroke: "#808080",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12.2003 4.80007V3",
    stroke: "#808080",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M12.2003 4.80006C13.7916 4.80006 15.3178 5.43223 16.4431 6.55749C17.5683 7.68275 18.2005 9.20893 18.2005 10.8003C18.2005 16.4373 19.4005 17.4005 19.4005 17.4005H5C5 17.4005 6.20004 15.8677 6.20004 10.8003C6.20004 9.20893 6.83221 7.68275 7.95747 6.55749C9.08273 5.43223 10.6089 4.80006 12.2003 4.80006V4.80006Z",
    stroke: "#808080",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNotify);
export default __webpack_public_path__ + "static/media/notify.009f4c0705b5c7a5a3c908ff39b09da5.svg";
export { ForwardRef as ReactComponent };